import { render, staticRenderFns } from "./BenefitEdit.vue?vue&type=template&id=8174f6bc&"
import script from "./BenefitEdit.vue?vue&type=script&lang=js&"
export * from "./BenefitEdit.vue?vue&type=script&lang=js&"
import style0 from "./BenefitEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports